module.exports = __webpack_public_path__ + "static/media/promo.5cba5210.png";